/* bryan-foamer-configurator: running total, conditional groups, and multi-variant add to cart - Seth S. 2026.9.9 */

(function () {
  'use strict';

  function BryanFoamerConfigurator(root) {
    this.root = root;
    this.groups = Array.prototype.slice.call(root.querySelectorAll('[data-fc-group]'));
    this.summary = root.querySelector('[data-fc-summary]');
    this.totalEl = root.querySelector('[data-fc-total]');
    this.submitEl = root.querySelector('[data-fc-submit]');
    this.errorEl = root.querySelector('[data-fc-error]');
    this.panel = root.querySelector('[data-fc-panel]');
    this.panelToggle = root.querySelector('[data-fc-panel-toggle]');
    this.toggleHint = root.querySelector('[data-fc-toggle-hint]');
    this.modal = root.querySelector('[data-fc-modal]');
    this.modalBody = root.querySelector('[data-fc-modal-body]');
    this.modalClose = root.querySelector('[data-fc-modal-close].bryan-foamer-configurator__modal-close');
    this.modalOpener = null;

    this.formatter = this.buildFormatter(root.dataset.currency || 'USD');
    this.ensureSingleGroupsHaveAPick();
    this.bind();
    this.refresh();
  }

  /* bryan-fc-guarantee-pick: a choose-one group must never render with nothing
     selected. The pre-selected variant is matched by name in Liquid, and a rename
     in admin can stop it matching - which once left Primary Hose empty, so the
     build silently shipped without a hose. If a group comes back with no pick,
     take the first option that can be selected. */
  BryanFoamerConfigurator.prototype.ensureSingleGroupsHaveAPick = function () {
    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      if (group.dataset.fcGroupMode !== 'single') continue;
      if (group.querySelector('[data-fc-option]:checked')) continue;

      var options = group.querySelectorAll('[data-fc-option]');
      for (var j = 0; j < options.length; j++) {
        if (options[j].disabled) continue;
        if (options[j].dataset.fcUnmapped === 'true') continue;
        options[j].checked = true;
        break;
      }
    }
  };

  BryanFoamerConfigurator.prototype.buildFormatter = function (currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
    } catch (e) {
      return null;
    }
  };

  BryanFoamerConfigurator.prototype.money = function (cents) {
    var amount = cents / 100;
    if (this.formatter) return this.formatter.format(amount);
    return '$' + amount.toFixed(2);
  };

  BryanFoamerConfigurator.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('change', function (event) {
      if (event.target.matches('[data-fc-option]')) self.refresh();
    });

    this.root.addEventListener('click', function (event) {
      if (event.target.closest('[data-fc-modal-close]')) {
        self.closeModal();
        return;
      }

      var thumb = event.target.closest('[data-fc-thumb]');
      if (thumb) {
        self.showSlide(thumb.getAttribute('data-fc-thumb'));
        return;
      }

      var toggle = event.target.closest('[data-fc-details-toggle]');
      if (toggle) self.openModal(toggle);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.modal && !self.modal.hidden) self.closeModal();
    });

    if (this.submitEl) {
      this.submitEl.addEventListener('click', function () {
        self.addToCart();
      });
    }

    if (this.panelToggle) {
      this.panelToggle.addEventListener('click', function () {
        var open = self.panel.classList.toggle('is-open');
        self.panelToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (self.toggleHint) self.toggleHint.textContent = open ? 'Hide items' : 'Show items';
      });
    }
  };

  /* bryan-fc-reveal: a group is visible when it has no "show only for" keys, or when at
     least one of its keys is currently selected somewhere on the page. Hidden groups are
     excluded from the total and from the cart payload. - Seth S. 2026.9.9 */
  BryanFoamerConfigurator.prototype.activeRevealKeys = function () {
    var keys = {};
    var checked = this.root.querySelectorAll('[data-fc-option]:checked');
    for (var i = 0; i < checked.length; i++) {
      var key = (checked[i].dataset.fcRevealKey || '').trim();
      if (key) keys[key] = true;
    }
    return keys;
  };

  BryanFoamerConfigurator.prototype.applyReveal = function () {
    var active = this.activeRevealKeys();

    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      var showFor = (group.dataset.fcShowFor || '').trim();
      var visible = true;

      if (showFor) {
        visible = false;
        var wanted = showFor.split(',');
        for (var j = 0; j < wanted.length; j++) {
          if (active[wanted[j].trim()]) {
            visible = true;
            break;
          }
        }
      }

      group.hidden = !visible;
    }
  };

  BryanFoamerConfigurator.prototype.selections = function () {
    var out = [];

    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      if (group.hidden) continue;

      /* Locked items count whether or not the checkbox reads as checked. They are
         mandatory and the page gives nobody a way to switch them off, so their
         inclusion must not depend on a DOM state we do not control - a restored
         form state on back/forward would otherwise drop them silently. */
      var checked = group.querySelectorAll('[data-fc-option]:checked, [data-fc-option][data-fc-locked="true"]');
      for (var j = 0; j < checked.length; j++) {
        var input = checked[j];
        if (input.disabled) continue;
        if (input.dataset.fcUnmapped === 'true') continue;
        /* a None card is a real selection but buys nothing */
        if (input.dataset.fcNone === 'true') continue;

        out.push({
          id: parseInt(input.dataset.fcVariantId, 10),
          price: parseInt(input.dataset.fcPrice, 10) || 0,
          qty: parseInt(input.dataset.fcQty, 10) || 1,
          label: input.dataset.fcLabel || '',
          productTitle: input.dataset.fcProductTitle || '',
          group: group
        });
      }
    }

    return out;
  };

  /* What each group would contribute if one group's pick were swapped out. Passing
     no override describes the build as it stands. */
  BryanFoamerConfigurator.prototype.effectiveSelections = function (overrideGroup, overrideInput) {
    var out = [];

    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      var inputs;

      if (group === overrideGroup) {
        inputs = overrideInput ? [overrideInput] : [];
      } else {
        inputs = Array.prototype.slice.call(
          group.querySelectorAll('[data-fc-option]:checked, [data-fc-option][data-fc-locked="true"]')
        );
      }

      var usable = [];
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].disabled) continue;
        if (inputs[j].dataset.fcUnmapped === 'true') continue;
        usable.push(inputs[j]);
      }

      out.push({ group: group, inputs: usable });
    }

    return out;
  };

  /* bryan-fc-forced-cost: the least this group can cost once it is on screen.

     An "included" group forces everything in it. A choose-one group forces its
     cheapest option, unless it offers a None card, in which case the shopper can
     opt out and it forces nothing. An optional group forces nothing at all. */
  BryanFoamerConfigurator.prototype.forcedCost = function (group) {
    var mode = group.dataset.fcGroupMode;
    var options = group.querySelectorAll('[data-fc-option]');
    var hasNone = false;
    var cheapest = null;
    var sum = 0;

    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      if (opt.dataset.fcNone === 'true') {
        hasNone = true;
        continue;
      }
      if (opt.disabled) continue;
      if (opt.dataset.fcUnmapped === 'true') continue;

      var price = (parseInt(opt.dataset.fcPrice, 10) || 0) * (parseInt(opt.dataset.fcQty, 10) || 1);
      sum += price;
      if (cheapest === null || price < cheapest) cheapest = price;
    }

    if (mode === 'included') return sum;
    if (mode === 'single') {
      if (hasNone) return 0;
      return cheapest === null ? 0 : cheapest;
    }
    return 0;
  };

  /* Which groups would be on screen if one group's pick were swapped out. */
  BryanFoamerConfigurator.prototype.visibilityUnder = function (overrideGroup, overrideInput) {
    var sel = this.effectiveSelections(overrideGroup, overrideInput);
    var keys = {};
    var i, j;

    for (i = 0; i < sel.length; i++) {
      for (j = 0; j < sel[i].inputs.length; j++) {
        var key = (sel[i].inputs[j].dataset.fcRevealKey || '').trim();
        if (key) keys[key] = true;
      }
    }

    var map = [];
    for (i = 0; i < this.groups.length; i++) {
      var showFor = (this.groups[i].dataset.fcShowFor || '').trim();
      var visible = true;

      if (showFor) {
        visible = false;
        var wanted = showFor.split(',');
        for (var w = 0; w < wanted.length; w++) {
          if (keys[wanted[w].trim()]) {
            visible = true;
            break;
          }
        }
      }

      map.push(visible);
    }

    return map;
  };

  /* bryan-fc-forced-delta: what switching to this option really commits you to.

     Its own line, plus whatever the switch forces into or out of the build - a
     double foamer brings a second tank and makes a secondary hose compulsory - and
     nothing else. Groups that are on screen either way contribute the same on both
     sides and cancel, so picking a different hose length can never move the price
     shown on the foamer cards. Revealed groups are counted at their cheapest, so
     the figure is the unavoidable minimum rather than whatever happens to be
     pre-selected further down the page. - Seth S. 2026.9.15 */
  BryanFoamerConfigurator.prototype.forcedDelta = function (group, input) {
    var before = this.visibilityUnder(null, null);
    var after = this.visibilityUnder(group, input);

    var picked = group.querySelector('[data-fc-option]:checked');
    var currentPrice = 0;
    if (picked && picked.dataset.fcNone !== 'true') {
      currentPrice = (parseInt(picked.dataset.fcPrice, 10) || 0) * (parseInt(picked.dataset.fcQty, 10) || 1);
    }

    var candidatePrice = 0;
    if (input.dataset.fcNone !== 'true') {
      candidatePrice = (parseInt(input.dataset.fcPrice, 10) || 0) * (parseInt(input.dataset.fcQty, 10) || 1);
    }

    var delta = candidatePrice - currentPrice;

    for (var i = 0; i < this.groups.length; i++) {
      if (this.groups[i] === group) continue;
      if (before[i] === after[i]) continue;
      if (after[i]) {
        delta += this.forcedCost(this.groups[i]);
      } else {
        delta -= this.forcedCost(this.groups[i]);
      }
    }

    return delta;
  };

  /* bryan-fc-true-delta: the whole build total under a hypothetical pick, including
     any group that pick reveals or hides. A double foamer costs $200 more than a
     single on its own line, but choosing it also forces a secondary hose, so the
     honest number to show the shopper is the difference in grand total, not the
     difference between two line prices. Comparing line prices alone understated
     the double foamer by the entire price of a hose and gun. */
  BryanFoamerConfigurator.prototype.hypotheticalTotal = function (overrideGroup, overrideInput) {
    var sel = this.effectiveSelections(overrideGroup, overrideInput);
    var keys = {};
    var i, j;

    for (i = 0; i < sel.length; i++) {
      for (j = 0; j < sel[i].inputs.length; j++) {
        var key = (sel[i].inputs[j].dataset.fcRevealKey || '').trim();
        if (key) keys[key] = true;
      }
    }

    var total = 0;
    for (i = 0; i < sel.length; i++) {
      var showFor = (sel[i].group.dataset.fcShowFor || '').trim();
      var visible = true;

      if (showFor) {
        visible = false;
        var wanted = showFor.split(',');
        for (var w = 0; w < wanted.length; w++) {
          if (keys[wanted[w].trim()]) {
            visible = true;
            break;
          }
        }
      }

      if (!visible) continue;

      for (j = 0; j < sel[i].inputs.length; j++) {
        var unit = parseInt(sel[i].inputs[j].dataset.fcPrice, 10) || 0;
        var mult = parseInt(sel[i].inputs[j].dataset.fcQty, 10) || 1;
        total += unit * mult;
      }
    }

    return total;
  };

  /* In a choose-one group the selected card reads "Selected" and every other card
     shows what switching to it would do to the build total, with reductions in red.
     Optional groups keep absolute prices, because ticking a second add-on is not a
     swap and has no baseline to measure from. Always-included cards read "Included"
     and are left alone. */
  BryanFoamerConfigurator.prototype.paintPrices = function () {
    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      var mode = group.dataset.fcGroupMode;
      if (mode === 'included') continue;

      var options = group.querySelectorAll('[data-fc-option]');

      for (var j = 0; j < options.length; j++) {
        var input = options[j];
        var wrap = input.closest('.bryan-foamer-configurator__option');
        if (!wrap) continue;
        var el = wrap.querySelector('[data-fc-price-el]');
        if (!el || el.dataset.fcPriceStatic === 'true') continue;

        el.classList.remove(
          'bryan-foamer-configurator__price--selected',
          'bryan-foamer-configurator__price--down',
          'bryan-foamer-configurator__price--up'
        );

        var price = (parseInt(input.dataset.fcPrice, 10) || 0) * (parseInt(input.dataset.fcQty, 10) || 1);

        if (mode !== 'single') {
          el.textContent = this.money(price);
          continue;
        }

        if (input.checked) {
          el.textContent = 'Selected';
          el.classList.add('bryan-foamer-configurator__price--selected');
          continue;
        }

        var delta = this.forcedDelta(group, input);
        if (delta < 0) {
          el.textContent = '-' + this.money(-delta);
          el.classList.add('bryan-foamer-configurator__price--down');
        } else {
          el.textContent = '+' + this.money(delta);
          if (delta > 0) el.classList.add('bryan-foamer-configurator__price--up');
        }
      }
    }
  };

  BryanFoamerConfigurator.prototype.refresh = function () {
    this.applyReveal();
    this.paintPrices();

    var picks = this.selections();
    var total = 0;
    var i;

    /* echo the current selection into each visible group heading */
    for (i = 0; i < this.groups.length; i++) {
      var echo = this.groups[i].querySelector('[data-fc-echo]');
      if (!echo) continue;

      var names = [];
      var checked = this.groups[i].querySelectorAll('[data-fc-option]:checked, [data-fc-option][data-fc-locked="true"]');
      /* the same item can appear more than once in a group - a double foamer takes two
         tanks, shown as two cards - and repeating its name in the recap adds nothing */
      for (var k = 0; k < checked.length; k++) {
        if (checked[k].dataset.fcUnmapped === 'true') continue;
        var name = checked[k].dataset.fcLabel || '';
        if (names.indexOf(name) === -1) names.push(name);
      }
      echo.textContent = names.length ? names.join(', ') : 'None';
    }

    for (i = 0; i < picks.length; i++) total += picks[i].price * picks[i].qty;

    /* bryan-fc-summary: a recap of the build, one row per heading and no per-line
       prices. Groups sharing a Summary label merge onto one row, which is how a
       primary and a secondary hose read as a single "Hoses and Guns" line.

       The heading is shown unless the row is a single pick from a choose-one group,
       where the item names itself - "Double Foamer" needs no "Foamer Type:" in front
       of it. An optional group always shows its heading, because one bare "50'" tells
       a shopper nothing about what it is. - Seth S. 2026.9.15 */
    if (this.summary) {
      this.summary.innerHTML = '';

      var rows = [];
      var byLabel = {};

      for (i = 0; i < this.groups.length; i++) {
        var grp = this.groups[i];
        if (grp.hidden) continue;

        var titleEl = grp.querySelector('.bryan-foamer-configurator__group-title');
        var explicit = (grp.dataset.fcSummaryLabel || '').trim();
        var heading = explicit || (titleEl ? titleEl.textContent.trim() : '');
        var chosen = grp.querySelectorAll('[data-fc-option]:checked, [data-fc-option][data-fc-locked="true"]');
        var picked = [];

        for (var m = 0; m < chosen.length; m++) {
          if (chosen[m].disabled) continue;
          if (chosen[m].dataset.fcUnmapped === 'true') continue;
          if (chosen[m].dataset.fcNone === 'true') continue;
          var label = chosen[m].dataset.fcLabel || '';
          if (picked.indexOf(label) === -1) picked.push(label);
        }

        if (!picked.length) continue;

        var row = byLabel[heading];
        if (!row) {
          row = { heading: heading, items: [], alwaysLabel: !!explicit, anyOptional: false };
          byLabel[heading] = row;
          rows.push(row);
        }

        if (grp.dataset.fcGroupMode === 'multi') row.anyOptional = true;

        for (var n = 0; n < picked.length; n++) {
          if (row.items.indexOf(picked[n]) === -1) row.items.push(picked[n]);
        }
      }

      for (var q = 0; q < rows.length; q++) {
        var r = rows[q];
        var li = document.createElement('li');
        li.className = 'bryan-foamer-configurator__summary-item';

        var showHeading = r.alwaysLabel || r.anyOptional || r.items.length > 1;

        if (showHeading) {
          var tag = document.createElement('span');
          tag.className = 'bryan-foamer-configurator__summary-group';
          tag.textContent = r.heading + ': ';
          li.appendChild(tag);
          li.appendChild(document.createTextNode(r.items.join(', ')));
        } else {
          li.textContent = r.items[0];
        }

        this.summary.appendChild(li);
      }
    }

    if (this.totalEl) this.totalEl.textContent = this.money(total);
    if (this.submitEl) this.submitEl.disabled = picks.length === 0;
  };

  /* bryan-fc-modal: fetch the product's own media and description through the Section
     Rendering API and show it in place, so a shopper can inspect a part - including the
     video - without navigating away and losing a half-finished build. The link out to
     the full product page lives inside the modal and opens in a new tab. */
  BryanFoamerConfigurator.prototype.openModal = function (opener) {
    var self = this;
    var url = opener.getAttribute('data-fc-product-url');
    if (!this.modal || !url) return;

    this.modalOpener = opener;
    this.modalBody.innerHTML = '<p class="bryan-foamer-configurator__modal-loading">Loading&hellip;</p>';
    this.modal.hidden = false;
    document.body.classList.add('overflow-hidden');
    if (this.modalClose) this.modalClose.focus();

    var sep = url.indexOf('?') === -1 ? '?' : '&';

    fetch(url + sep + 'section_id=bryan-foamer-detail')
      .then(function (response) {
        if (!response.ok) throw new Error('detail fetch failed');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var detail = parsed.querySelector('[data-fc-detail]');
        if (!detail) throw new Error('detail markup missing');

        /* a shortened display name replaces the real product title in this view */
        var shortName = opener.getAttribute('data-fc-display-name');
        if (shortName) {
          var heading = detail.querySelector('.bryan-foamer-detail__title');
          if (heading) heading.textContent = shortName;
        }

        /* unlisted products have no page worth sending a shopper to */
        if (opener.getAttribute('data-fc-hide-link')) {
          var link = detail.querySelector('.bryan-foamer-detail__link');
          if (link) link.parentNode.removeChild(link);
        }

        /* a block-level Details override replaces the product's own copy */
        var override = opener.getAttribute('data-fc-details-override');
        if (override) {
          var desc = detail.querySelector('[data-fc-detail-desc]');
          if (desc) desc.innerHTML = override;
        }

        self.modalBody.innerHTML = '';
        self.modalBody.appendChild(detail);
      })
      .catch(function () {
        self.modalBody.innerHTML =
          '<p class="bryan-foamer-configurator__modal-loading">Could not load these details. ' +
          '<a href="' + url + '" target="_blank" rel="noopener">Open the product page</a> instead.</p>';
      });
  };

  BryanFoamerConfigurator.prototype.closeModal = function () {
    if (!this.modal || this.modal.hidden) return;

    /* stop any playing video dead rather than leaving it running behind the overlay */
    var players = this.modalBody.querySelectorAll('video');
    for (var i = 0; i < players.length; i++) {
      try {
        players[i].pause();
      } catch (e) {}
    }
    this.modalBody.innerHTML = '';

    this.modal.hidden = true;
    document.body.classList.remove('overflow-hidden');
    if (this.modalOpener) this.modalOpener.focus();
    this.modalOpener = null;
  };

  BryanFoamerConfigurator.prototype.showSlide = function (index) {
    var slides = this.modalBody.querySelectorAll('[data-fc-slide]');
    var thumbs = this.modalBody.querySelectorAll('[data-fc-thumb]');
    var i;

    for (i = 0; i < slides.length; i++) {
      var on = slides[i].getAttribute('data-fc-slide') === String(index);
      slides[i].classList.toggle('is-active', on);
      if (!on) {
        var v = slides[i].querySelector('video');
        if (v) {
          try {
            v.pause();
          } catch (e) {}
        }
      }
    }

    for (i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.toggle('is-active', thumbs[i].getAttribute('data-fc-thumb') === String(index));
    }
  };

  BryanFoamerConfigurator.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = !message;
  };

  BryanFoamerConfigurator.prototype.buildId = function () {
    return Math.random().toString(36).slice(2, 6).toUpperCase();
  };

  BryanFoamerConfigurator.prototype.addToCart = function () {
    var self = this;
    var picks = this.selections();

    if (!picks.length) {
      this.showError('Choose at least one item before adding to the cart.');
      return;
    }

    this.showError('');
    this.submitEl.setAttribute('aria-busy', 'true');
    this.submitEl.disabled = true;

    /* the same variant can be picked in more than one group, so merge quantities */
    var merged = {};
    var order = [];
    for (var i = 0; i < picks.length; i++) {
      var id = picks[i].id;
      if (merged[id]) {
        merged[id].quantity += picks[i].qty;
      } else {
        merged[id] = { id: id, quantity: picks[i].qty };
        order.push(id);
      }
    }

    var buildId = this.buildId();
    var items = [];
    for (var j = 0; j < order.length; j++) {
      items.push({
        id: merged[order[j]].id,
        quantity: merged[order[j]].quantity,
        /* "Part of" mirrors how the Bundles app labels a bundled line, so the cart,
           order and packing slip all read the same way. The build id stays on the
           hidden property so two separate builds in one cart can still be told
           apart in code. */
        properties: {
          _bryan_build_id: buildId,
          'Part of': 'Foamer Configurator'
        }
      });
    }

    var body = { items: items };
    var cartDrawer = document.querySelector('cart-drawer');
    var useDrawer = cartDrawer && typeof cartDrawer.renderContents === 'function';

    if (useDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsed) {
        if (parsed.status) {
          self.showError(parsed.description || parsed.message || 'Could not add this build to the cart.');
          return;
        }

        if (useDrawer) {
          cartDrawer.renderContents(parsed);
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        } else {
          window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        }
      })
      .catch(function () {
        self.showError('Something went wrong adding this build. Please try again.');
      })
      .finally(function () {
        self.submitEl.removeAttribute('aria-busy');
        self.refresh();
      });
  };

  function init() {
    var roots = document.querySelectorAll('[data-bryan-foamer-configurator]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].dataset.fcReady) {
        roots[i].dataset.fcReady = 'true';
        new BryanFoamerConfigurator(roots[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* re-init when the theme editor re-renders the section */
  document.addEventListener('shopify:section:load', init);
})();
